/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { IResourceProps } from './ResourceLoader';
import { RESOURCE } from './ResourceType';

const webtopPath = '/public/images/full_wt/';
function makeFullPath(path: string): string {
    return webtopPath + path;
}

abstract class ResourceModel {
    // static
    static readonly propNames = ['caption', 'description'];
    // instance
    type: RESOURCE;
    id: string;
    description: string;
    caption: string;

    constructor(id: string, resource: IResourceProps) {
        this.validateProps(id, resource);

        this.id = id;
        this.description = resource.props.description;
        this.caption = resource.props.caption;

        if (!this.caption) {
            // null check override: split always returns non-empty array
            this.caption = id.split('/').pop()!;
        }
    }

    getPropNames(): string[] {
        return ResourceModel.propNames;
    }

    validateProps(id: string, resource: IResourceProps) {
        if (!resource) {
            throw new Error(`Resource of ${id} have no properties defined`);
        }
        const propNames = this.getPropNames();
        for (const propName of propNames) {
            if (resource.props[propName] === undefined) {
                let constructor = String(this.constructor);
                constructor = constructor.substr(0, constructor.indexOf('('));
                throw new Error(`Resource of ${id} in ${constructor} should have property ${propName} in props`);
            }
        }
    }

    launchResource() {
        throw new Error(`Resource ${this.type} ${this.id} has no launch implemented`);
    }
}

export { ResourceModel as default, ResourceModel, makeFullPath };
